import React from 'react';
import styled from 'styled-components';

export interface KnisaCreatePageLayoutProps {
    title: string;
    children: React.ReactNode;
    className?: string;
    maxWidth?: string;
}

const KnisaCreatePageLayout: React.FC<KnisaCreatePageLayoutProps> = ({
    title,
    children,
    className,
    maxWidth = '1000px',
}) => (
    <Page className={className}>
        <Container $maxWidth={maxWidth}>
            <Header>
                <Title>{title}</Title>
            </Header>
            <Content>{children}</Content>
        </Container>
    </Page>
);

export default KnisaCreatePageLayout;

const Page = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.bgLayout};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    isolation: isolate;
`;

const Container = styled.div<{ $maxWidth: string }>`
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: ${({ $maxWidth }) => $maxWidth};
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    direction: rtl;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 0.375rem;
    }
`;

const Header = styled.header`
    padding: 0 0.25rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h1`
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.lg};
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.ink};
    text-align: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.xl};
    }
`;

const Content = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;
